// extracted by mini-css-extract-plugin
export default {"header":"header_header__1cypG","subTitle":"header_subTitle__bYv2T","mr4":"header_mr4__VNwK3"};